module.exports = __webpack_public_path__ + "media/fonts/RecklessNeue-Book-3411117cd9b88080be19ea6e1f6c7ef3.ttf";